/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Chronoctlnotifiers";
const frontMatter = {};
import {Alert} from '@/components';
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    a: "a",
    code: "code",
    p: "p",
    pre: "pre",
    span: "span",
    ..._provideComponents(),
    ...props.components
  };
  return <><_components.p>{"To create one or more notifiers using "}<_components.a href="/tooling/chronoctl">{"Chronoctl"}</_components.a>{", create a YAML file\nthat defines them and apply the configuration to your instance."}</_components.p>{"\n"}<Alert severity="info"><_components.p>{"You can use the "}<_components.code>{"notifiers scaffold"}</_components.code>{" command to generate an example notifier, and\nthen copy the resource definition for your notifier type:"}</_components.p><_components.pre tabIndex="0" data-language="shell" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"chronoctl"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" notifiers"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" scaffold"}</_components.span></_components.span></_components.code></_components.pre></Alert></>;
}

export default MDXLayout